import { APIClient } from '@frontend/api-utils';
import { Package, PackageStateName, PackageTriggerName } from '@frontend/package/types';
import { TriggerBody } from '@frontend/workflow/types';

export class PackageWorkflowClient extends APIClient {
    public static readonly endpoint = '/package-api/v1';

    public static async updatePackageState(accountId: string, transactionId: string, packageId: string, state: PackageStateName): Promise<Package> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/packages/${packageId}/change-state`, {
            state: state
        });
        return await this.handleResponse<Package>(response);
    }

    public static async triggerPackageState(
        accountId: string,
        transactionId: string,
        packageId: string,
        trigger: TriggerBody<PackageTriggerName>
    ): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/packages/${packageId}/trigger`, trigger);
        return await this.handleVoidResponse(response);
    }
}
